module.exports = __webpack_public_path__ + "img/defaqto-rating-5-star.24c386c9.svg";